export * from './window-type-2.component';